import { createSelector } from "reselect";
import { getSizotsaFuneralClaim } from "./index";

import {SZ_CLAIM_PAGE_INDICES} from "../../actions/sizotsaFuneralClaim/types"

export const getRouting = createSelector(
  getSizotsaFuneralClaim,
  (sizotsaFuneralClaim) => sizotsaFuneralClaim.routing
);
export const getActivePageIndex = createSelector(
  getRouting,
  (routing) => routing.activePageIndex
);
export const getDoNavigation = createSelector(
  getRouting,
  (routing) => routing.doNavigation
);
export const getDoExitNavigation = createSelector(
  getRouting,
  (routing) => routing.doExitNavigation
);

export const makeGetIsPage = (pageIndex) =>
  createSelector(
    getRouting,
    (routing) => routing.activePageIndex === pageIndex
  );
export const getIsDropoffPage = createSelector(
  getRouting,
  (routing) => routing.activePageIndex === 1
);

export const getIsClaimentPage = makeGetIsPage(
  SZ_CLAIM_PAGE_INDICES.CLAIMENT_DETAILS
);
export const getIsDeceasedPage = makeGetIsPage(
  SZ_CLAIM_PAGE_INDICES.DECEASED_DETAILS
);
export const getIsUplaoadDocumentsPage = makeGetIsPage(
  SZ_CLAIM_PAGE_INDICES.UPLOAD_DOCUMENTS
);

export const getProgressBarSteps= createSelector(
    getRouting,(routing)=>routing.progressBarSteps
)

// used by the application wizard footer
export const getContinueButtonText = createSelector(
  getActivePageIndex,
  (activePageIndex) => {
    return activePageIndex === SZ_CLAIM_PAGE_INDICES.UPLOAD_DOCUMENTS
      ? "SUBMIT"
      : "CONTINUE";
  }
);


// used by the application wizard header
// TODO: Implement page types and remove magic numbers
export const getHideMobile = createSelector(
  getActivePageIndex,
  (activePageIndex) => {
    return activePageIndex === 7;
  }
);
